import { Reveal } from "@/components/Reveal";
import { SectionHeading, CornerTicks } from "@/components/kit";

const PHASES = [
    {
        num: "01",
        name: "FOUNDATION",
        status: "SPECIFICATION",
        items: ["Action Proof specification", "Protocol architecture", "Agent identity model", "Documentation"],
    },
    {
        num: "02",
        name: "PROTOCOL",
        status: "PLANNED",
        items: ["Task infrastructure", "Evidence layer", "Verification engine", "Reputation model"],
    },
    {
        num: "03",
        name: "ARC ECONOMY",
        status: "PLANNED",
        items: ["Arc integration", "USDC settlement", "Agent marketplace", "Proof explorer"],
    },
    {
        num: "04",
        name: "AUTONOMOUS ECONOMY",
        status: "LONG TERM",
        items: ["AI agents", "Robotics", "IoT", "Machine-to-machine commerce"],
    },
];

export const RoadmapSection = () => (
    <section id="roadmap" data-testid="roadmap" className="section relative">
        <div className="shell">
            <Reveal>
                <div className="flex flex-wrap items-end justify-between gap-6">
                    <SectionHeading
                        index="10"
                        eyebrow="ROADMAP"
                        title={
                            <>
                                PHASED BUILD.
                                <br />
                                NO <span className="text-[#1677FF]">SHORTCUTS.</span>
                            </>
                        }
                    />
                    <p className="label-tech">STATUS: PRE-LAUNCH — NO DATES INVENTED</p>
                </div>
            </Reveal>

            <div className="mt-12 grid gap-px border border-white/[0.08] bg-white/[0.06] md:grid-cols-2 xl:grid-cols-4">
                {PHASES.map((p, i) => (
                    <Reveal key={p.num} delay={i * 0.07} className="h-full">
                        <div className="relative flex h-full flex-col bg-[#07111F] p-7 transition-colors duration-300 hover:bg-[#0A1627]">
                            <div className="flex items-start justify-between">
                                <span className="font-display text-5xl font-bold text-stroke">{p.num}</span>
                                <span
                                    className={`font-mono text-[9px] uppercase tracking-[0.2em] ${
                                        p.status === "SPECIFICATION" ? "text-[#31D8FF]" : "text-mute/60"
                                    }`}
                                >
                                    {p.status}
                                </span>
                            </div>
                            <h3 className="mt-8 font-display text-lg font-bold uppercase tracking-tightest">{p.name}</h3>
                            <ul className="mt-4 space-y-2.5">
                                {p.items.map((item) => (
                                    <li key={item} className="flex items-start gap-2.5 text-sm text-mute">
                                        <span className="mt-[7px] h-1 w-1 shrink-0 bg-[#1677FF]" aria-hidden="true" />
                                        {item}
                                    </li>
                                ))}
                            </ul>
                        </div>
                    </Reveal>
                ))}
            </div>

            <Reveal delay={0.2}>
                <div className="relative mt-8 p-6">
                    <CornerTicks />
                    <p className="text-center font-mono text-[10px] uppercase tracking-[0.26em] text-mute">
                        PHASES DESCRIBE BUILD ORDER — TIMELINES ARE PUBLISHED WITH THE PROTOCOL SPECIFICATION
                    </p>
                </div>
            </Reveal>
        </div>
    </section>
);

export default RoadmapSection;
